import { Paper, Typography, Box } from '@mui/material';
import {
  ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid, LabelList,
} from 'recharts';

interface Props {
  data: { month: string; total: number }[];
}

const RevenueAreaChart = ({ data }: Props) => {
  const grandTotal = data.reduce((s, d) => s + d.total, 0);

  return (
    <Paper elevation={0} sx={{
      p: { xs: 2, md: 3 }, borderRadius: 3,
      border: '1px solid #e5e7eb', height: '100%',
    }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
        <Typography fontWeight={700} sx={{ fontSize: '0.95rem', color: '#0f172a' }}>
          월별 매출 추이
        </Typography>
        <Typography sx={{ fontSize: '0.82rem', fontWeight: 700, color: '#16a34a' }}>
          총 ₩{grandTotal.toLocaleString()}
        </Typography>
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
        완료 건의 최종 금액 합계 ({data.length}개월)
      </Typography>
      <Box sx={{ width: '100%', height: 280 }}>
        {data.length === 0 ? (
          <Box display="flex" alignItems="center" justifyContent="center" height="100%">
            <Typography color="text.secondary" fontSize="0.85rem">데이터가 없습니다</Typography>
          </Box>
        ) : (
          <ResponsiveContainer>
            <AreaChart data={data} margin={{ top: 20, right: 10, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="revenueGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#1976d2" stopOpacity={0.3} />
                  <stop offset="100%" stopColor="#1976d2" stopOpacity={0.02} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis
                dataKey="month"
                tick={{ fontSize: 11, fill: '#94a3b8' }}
                axisLine={false} tickLine={false}
                padding={{ left: 10, right: 10 }}
              />
              <YAxis
                tick={{ fontSize: 11, fill: '#94a3b8' }}
                axisLine={false} tickLine={false}
                tickFormatter={(v) => v >= 10000 ? `${(v / 10000).toFixed(0)}만` : v.toLocaleString()}
                width={50}
              />
              <Tooltip
                contentStyle={{
                  borderRadius: 10, border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)', fontSize: '0.85rem',
                }}
                formatter={(value: number) => [`₩${value.toLocaleString()}`, '매출']}
                labelFormatter={(label: string) => `${label}월`}
              />
              <Area
                type="monotone" dataKey="total"
                stroke="#1976d2" strokeWidth={2.5}
                fill="url(#revenueGradient)"
                dot={{ r: 4, fill: '#fff', stroke: '#1976d2', strokeWidth: 2 }}
                activeDot={{ r: 6, fill: '#1976d2' }}
              >
                <LabelList
                  dataKey="total"
                  position="top"
                  style={{ fontSize: '0.65rem', fontWeight: 600, fill: '#64748b' }}
                  formatter={(v: number) => v >= 10000 ? `${(v / 10000).toFixed(0)}만` : v > 0 ? v.toLocaleString() : ''}
                  offset={8}
                />
              </Area>
            </AreaChart>
          </ResponsiveContainer>
        )}
      </Box>
    </Paper>
  );
};

export default RevenueAreaChart;
